// @ts-nocheck
import allUserRequest from '@/utils/request'
const userReFix = "user"

//获取所有正常用户列表
export function getAllUsers() {
    return allUserRequest({
        url: userReFix + '/Home/allUser',
        method: 'GET',
    })
}